export const namespaced = true;

export const state = {
    item: null,
    mainElementInfo: null,
    show: false,
    activeElementId: 0,
}

export const mutations = {
    SET_ITEM(state, element) {
        state.item = element;
    },

    UPDATE_ITEM(state, { value, key, changeFromScene }) {
        state.item = { ...state.item, [key]: value, changeFromScene, action: key }
    },


    SET_SHOW(state, show) {
        state.show = show;
    },

    SET_ACTIVE_ELEMENT_ID(state, activeElementId) {
        state.activeElementId = activeElementId;
    },

    SET_OFFSET(state, { offsetTop, offsetLeft, changeFromScene = null }) {
        state.item = {
            ...state.item,
            offsetTop: offsetTop.toFixed(1),
            offsetLeft: offsetLeft.toFixed(1),
            changeFromScene
        }
    },

    SET_MAIN_ELEMENT_INFO(state, info) {
        state.mainElementInfo = info;;
    },

    CLEAR(state) {
        state.item = null;
        // state.mainElementInfo = null;
    },
}

export const actions = {

    async setItem({ commit }, element) {
        commit('SET_ITEM', element);
    },

    async updateItem({ commit }, { value, key }) {
        commit("UPDATE_ITEM", { value, key, changeFromScene: null });
    },

    async setShow({ commit }, show) {
        commit('SET_SHOW', show);
    },

    async setActiveElementId({ commit }, activeElementId) {
        commit('SET_ACTIVE_ELEMENT_ID', activeElementId);
    },

    async setOffset({ commit }, offset) {
        commit('SET_OFFSET', offset);
    },

    async setMainElementInfo({ commit }, info) {
        commit('SET_MAIN_ELEMENT_INFO', info);
    },

    async clear({ commit }) {
        commit('CLEAR');
    },
}
